import React, { useState, useEffect } from "react";
import PageWrapperForm from "../../components/PageWrapperForm";
import { fetchWrapper } from "utils/apiFetch";

const SmsPasswordPage = () => {
  const [smsPassword, setSmsPassword] = useState("");
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState(null); // { text, type }

  // GET current sms_password on mount
  useEffect(() => {
    const fetchData = async () => {
      try {
        const formdata = new FormData();
        formdata.append("action", "GET");

        const result = await fetchWrapper("https://api.mokshiq.in/company_action", {
          method: "POST",
          body: formdata,
        });

        if (result?.data?.length > 0) {
          setSmsPassword(result.data[0].sms_password || "");
        }
      } catch (err) {
        setMessage({ text: "Failed to load SMS password.", type: "danger" });
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // UPDATE sms_password
  const handleUpdate = async () => {
    setSaving(true);
    setMessage(null);
    try {
      const formdata = new FormData();
      formdata.append("action", "UPDATE_SMS_PASSWORD");
      formdata.append("sms_password", smsPassword);

      const result = await fetchWrapper("https://api.mokshiq.in/company_action", {
        method: "POST",
        body: formdata,
      });

      if (result.status) {
        setMessage({ text: result.data, type: "success" });
      } else {
        setMessage({ text: result.data, type: "danger" });
      }
    } catch (err) {
      setMessage({ text: "Something went wrong.", type: "danger" });
    } finally {
      setSaving(false);
    }
  };

  return (
    <PageWrapperForm
      config={{ title: "SMS Password", breadcrumb: ["Settings", "SMS Password"] }}
    >
      <div className="card">
        <div className="card-header">
          <h5 className="card-title mb-0">Update SMS Password</h5>
        </div>
        <div className="card-body">
          {message && (
            <div className={`alert alert-${message.type}`} role="alert">
              {message.text}
            </div>
          )}

          {loading ? (
            <p>Loading...</p>
          ) : (
            <div className="row">
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="form-label">New Section</label>
                  <input
                    type="text"
                    className="form-control"
                    value={smsPassword}
                    onChange={(e) => setSmsPassword(e.target.value)}
                    placeholder="Enter News Section Content"
                  />
                </div>
                <button
                  className="btn btn-primary"
                  onClick={handleUpdate}
                  disabled={saving}
                >
                  {saving ? "Updating..." : "Update News"}
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </PageWrapperForm>
  );
};

export default SmsPasswordPage;